import CourseCompletionGroup from "@api/types/course-completion-group";
import { CFC } from "@api/types/cypress";
import React, { Fragment } from "react";

import EnrolledCourseGroup from "@components/EnrolledCourseGroup";
import Spacer from "@components/Spacer";

const EnrolledCourseGroups: CFC<{
  enrollmentGroups: CourseCompletionGroup[];
}> = ({ enrollmentGroups }) => {
  return (
    <>
      {enrollmentGroups.map((g) => {
        return (
          <Fragment key={g.id}>
            <EnrolledCourseGroup enrollmentGroup={g} />
            <Spacer size={"lg"} />
          </Fragment>
        );
      })}
    </>
  );
};

export default EnrolledCourseGroups;
